/**
 * Fork overlay (new file, no OSS equivalent) — EVA-M4.
 * Account-scoped client for the Eva Copilot API
 * (/api/v1/accounts/:account_id/eva/copilot_threads[/:id/copilot_messages]).
 */
/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

class EvaCopilotAPI extends ApiClient {
  constructor() {
    super('eva/copilot_threads', { accountScoped: true });
  }

  // List the requesting agent's own threads.
  getThreads() {
    return axios.get(this.url);
  }

  // Start a thread with the agent's first message; the reply streams back over ActionCable.
  createThread({ message, conversationId }) {
    return axios.post(this.url, { message, conversation_id: conversationId });
  }

  getMessages(threadId) {
    return axios.get(`${this.url}/${threadId}/copilot_messages`);
  }

  createMessage(threadId, { message, conversationId }) {
    return axios.post(`${this.url}/${threadId}/copilot_messages`, {
      message,
      conversation_id: conversationId,
    });
  }
}

export default new EvaCopilotAPI();
